import { Fancybox } from "@fancyapps/ui";

import menu from "./components/Menu"
import callback from "./components/Callback";
import swiper from "./components/Swiper";
import collapse from "./components/Collapse";
import scroll from "./components/Scroll";
import toggler from "./components/Toggler";
import test from "./components/Test";
import tabs from "./components/Tabs";
try {
    window.$ = window.jQuery = require('jquery');
    window._ = require('lodash');

    menu();
    callback();

    swiper();

    collapse();
    tabs();
    scroll();
    //toggler()
    test();
} catch (e) {
    console.log(e);
}

Fancybox.bind("[data-fancybox]", {
    // Your options go here
});